import { render, staticRenderFns } from "./MigrationLog.vue?vue&type=template&id=005a0e37&scoped=true"
import script from "./MigrationLog.vue?vue&type=script&lang=js"
export * from "./MigrationLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005a0e37",
  null
  
)

export default component.exports